module.exports = __webpack_public_path__ + "img/network_icon.a4a278ff.svg";